<tbs-dialog tbsSeparator="top-bottom">
  <tbs-dialog-header tbsHeading="Files"></tbs-dialog-header>
  <mat-dialog-content>
    <app-file-tree-node [nodes]="treeData"></app-file-tree-node>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button tbs-button mat-dialog-close>Close</button>
  </div>
</tbs-dialog>
